import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20a6ed69"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex align-items-center justify-content-between flex-wrap gap-3" }
const _hoisted_2 = { class: "flex align-items-center gap-2 flex-wrap" }
const _hoisted_3 = { class: "text-sm text-color-secondary mb-4 mt-0" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Secondary MDA", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Simulate offline", -1))
const _hoisted_6 = { class: "flex align-items-center gap-2" }
const _hoisted_7 = { class: "text-sm text-color-secondary" }
const _hoisted_8 = {
  key: 0,
  class: "text-xs text-color-secondary mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WTitle = _resolveComponent("WTitle")!
  const _component_WSubTitle = _resolveComponent("WSubTitle")!
  const _component_PButton = _resolveComponent("PButton")!
  const _component_PColumn = _resolveComponent("PColumn")!
  const _component_PTag = _resolveComponent("PTag")!
  const _component_PInputSwitch = _resolveComponent("PInputSwitch")!
  const _component_PDataTable = _resolveComponent("PDataTable")!
  const _component_PCard = _resolveComponent("PCard")!

  return (_openBlock(), _createBlock(_component_PCard, null, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createVNode(_component_WTitle, { text: "Health Check" }),
          _createVNode(_component_WSubTitle, { text: "Monitor subsystem health and simulate components going offline" })
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_PButton, {
            loading: _ctx.loading,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refresh())),
            icon: "pi pi-refresh",
            label: "Refresh",
            rounded: "",
            size: "small",
            text: ""
          }, null, 8, ["loading"]),
          (_ctx.canManage)
            ? (_openBlock(), _createBlock(_component_PButton, {
                key: 0,
                disabled: !_ctx.anySimulated || _ctx.saving,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearAll())),
                icon: "pi pi-times",
                label: "Clear simulations",
                rounded: "",
                severity: "secondary",
                size: "small"
              }, null, 8, ["disabled"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("p", _hoisted_3, [
        _createTextVNode(" PASS receives status only from "),
        _hoisted_4,
        _createTextVNode(", which reports itself and the other subsystems. If Secondary MDA is offline (live or simulated), every other component is treated as offline too. Turning "),
        _hoisted_5,
        _createTextVNode(" on forces that component down in the system status bar (and triggers the alert sound) without stopping the MDA feed. "),
        _createElementVNode("a", {
          class: "alert-settings-link ml-1",
          href: "#",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.goToAlertSettings()), ["prevent"]))
        }, "Alert sound settings")
      ]),
      _createVNode(_component_PDataTable, {
        loading: _ctx.loading,
        rowHover: true,
        showGridlines: true,
        stripedRows: true,
        value: _ctx.components,
        "data-key": "key",
        size: "small"
      }, {
        empty: _withCtx(() => [
          _createTextVNode("No health data available.")
        ]),
        default: _withCtx(() => [
          _createVNode(_component_PColumn, {
            field: "label",
            header: "Component",
            headerClass: "py-3"
          }),
          _createVNode(_component_PColumn, {
            header: "Live",
            headerClass: "py-3",
            style: {"width":"8rem"}
          }, {
            body: _withCtx(({ data }) => [
              _createVNode(_component_PTag, {
                severity: data.live ? 'success' : 'danger'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(data.live ? 'Online' : 'Offline'), 1)
                ]),
                _: 2
              }, 1032, ["severity"])
            ]),
            _: 1
          }),
          _createVNode(_component_PColumn, {
            header: "Effective",
            headerClass: "py-3",
            style: {"width":"8rem"}
          }, {
            body: _withCtx(({ data }) => [
              _createVNode(_component_PTag, {
                severity: data.effective ? 'success' : 'danger'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(data.effective ? 'Online' : 'Offline'), 1)
                ]),
                _: 2
              }, 1032, ["severity"])
            ]),
            _: 1
          }),
          _createVNode(_component_PColumn, {
            header: "Simulate offline",
            headerClass: "py-3",
            style: {"width":"12rem"}
          }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_PInputSwitch, {
                  disabled: !_ctx.canManage || _ctx.saving,
                  modelValue: data.simulated_offline,
                  "onUpdate:modelValue": (val) => _ctx.toggleOffline(data.key, !!val)
                }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"]),
                _createElementVNode("span", _hoisted_7, _toDisplayString(data.simulated_offline ? 'Forced offline' : 'Normal'), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading", "value"]),
      (_ctx.statusTs)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Last heartbeat: " + _toDisplayString(_ctx.statusTs), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}